<template>
  <BarChart
    :chart-width="722"
    :chart-height="296"
    :max-bar-width="40"
    :chart-margin="{ top: 50, right: 0, bottom: 50, left: 0 }"
    :commuters="computedData.data.entries"
    :colors="computedData.data.colors"
  />
</template>

<script>
import Computing from '@/components/Analysis/Computing';
import BarChart from '@/components/Chart/Bar';

export default {
  components: {
    BarChart,
  },

  mixins: [Computing],
  props: ['data', 'index', 'range'],

  computed: {
    computedData() {
      const { collaboratorsByRegion } = this.data;
      let sortedRegion = collaboratorsByRegion
        .slice(0)
        .sort((a, b) => {
          return b.count - a.count;
        })
        .filter(item => item.count > 0 && item.percentage > 0)
        .map(item => {
          const { caption, percentage, country } = item;
          return [`${caption}|${country === 'Non renseigné' ? 'France' : country}`, percentage / 100];
        });

      if (sortedRegion.length > 8) {
        const otherRegion = [`${this.$t('other')}|${this.$t('other')}`, 1 - sortedRegion.slice(0, 7).reduce((acc, value) => acc + value[1], 0)];
        sortedRegion = [...sortedRegion.slice(0, 7), otherRegion];
      }

      return {
        data: {
          entries: sortedRegion,
          colors: ['#d60808', '#d8d8d8', '#f1e7ca', '#8b8181', '#9a054a', '#602376', '#7874b5', '#ed700a'],
        },
      };
    },
  },
};
</script>
